import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'DineSafe — Franklin County Inspection Map';
render(<App data-id="element-166" />, document.getElementById('root'));